import { Map } from 'immutable';
import {
  CANCEL_CHECK_LOGIN,
  LOGIN,
  LOGIN_FAILURE,
  LOGIN_SUCCESS,
  LOGIN_WAIT,
  LOGOUT_SUCCESS,
  SET_AUTHENTICATION,
  SET_QR_CODE,
  CHECK_LOGIN_START,
  CHECK_LOGIN_END
} from './auth.actionTypes';

const initialState = Map().merge({
  login: {
    usuarioNroDeDocumento: '',
    sesionLatitud: '',
    sesionLongitud: '',
  },
  isLoading: false,
  isWaiting: false,
  isAuthenticated: null,
  authenticatedError: false,
  authenticatedErrorMessage: '',
  webToken: '',
  userLogged: {},
  qrCode: null,
  isCheckingLogin: false
});

const authReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case LOGIN:
      return state.merge({
        authenticatedError: false,
        authenticatedErrorMessage: '',
        isLoading: true,
      });
    case LOGIN_WAIT:
      return state.merge({
        authenticatedError: false,
        authenticatedErrorMessage: '',
        isLoading: true,
        isWaiting: true,
        webToken: payload.webToken
      });
    case CANCEL_CHECK_LOGIN:
      return state.merge({
        authenticatedError: false,
        authenticatedErrorMessage: 'Se ha excedido el tiempo de verificación de identidad. Reintente.',
        isLoading: false,
        isWaiting: false,
      });
    case LOGIN_SUCCESS:
      return state.merge({
        isAuthenticated: payload.isAuthenticated,
        userLogged: payload.userLogged,
        authenticatedError: false,
        authenticatedErrorMessage: '',
        isLoading: false,
        isWaiting: false,
      });
    case SET_AUTHENTICATION:
      return state.merge({
        isAuthenticated: payload.isAuthenticated,
        authenticatedError: false,
        authenticatedErrorMessage: '',
      });
    case LOGOUT_SUCCESS:
      return state.merge({
        isAuthenticated: false,
        authenticatedError: false,
        authenticatedErrorMessage: '',
        userLogged: {},
      });
    case LOGIN_FAILURE:
      return state.merge({
        authenticatedError: true,
        authenticatedErrorMessage: payload.authenticatedErrorMessage,
        isLoading: false,
        isWaiting: false,
      });
    case SET_QR_CODE:
      return state.merge({
        qrCode: payload.qrCode
      });
    case CHECK_LOGIN_START:
      return state.merge({
        isCheckingLogin: true
      });
    case CHECK_LOGIN_END:
      return state.merge({
        isCheckingLogin: false
      });
    default:
      return state;
  }
};

export default authReducer;



// WEBPACK FOOTER //
// ./src/state/auth/auth.reducer.js